import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    animate,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';
import { Toast } from 'ngx-toastr';

type AncToastTone = 'success' | 'error' | 'warning' | 'info';

const TONE_ICON: Record<AncToastTone, string> = {
    success: 'icon-check-circle',
    error: 'icon-alert-circle',
    warning: 'icon-alert-triangle',
    info: 'icon-info'
};

/**
 * DS "Snackbar" toast (Figma node 667:48616 and siblings). Registered as
 * ngx-toastr's `toastComponent` so every existing `ToastrService.success/error/
 * warning/info(...)` call site keeps working unchanged; only the render swaps.
 */
@Component({
    selector: 'lib-anc-toast',
    imports: [CommonModule],
    templateUrl: './anc-toast.component.html',
    styleUrls: ['./anc-toast.component.scss'],
    preserveWhitespaces: false,
    host: {
        '[class]': 'toastClasses',
        '[style.display]': 'displayStyle',
        '[@flyInOut]': '_state',
        '(click)': 'tapToast()',
        '(mouseenter)': 'stickAround()',
        '(mouseleave)': 'delayedHideToast()'
    },
    animations: [
        trigger('flyInOut', [
            state('inactive', style({ opacity: 0 })),
            state('active', style({ opacity: 1 })),
            state('removed', style({ opacity: 0 })),
            transition(
                'inactive => active',
                animate('{{ easeTime }}ms {{ easing }}')
            ),
            transition(
                'active => removed',
                animate('{{ easeTime }}ms {{ easing }}')
            )
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncToastComponent extends Toast {
    get tone(): AncToastTone {
        const type = this.toastPackage.toastType.replace(
            'toast-',
            ''
        ) as AncToastTone;
        return TONE_ICON[type] ? type : 'info';
    }

    get iconClass(): string {
        return TONE_ICON[this.tone];
    }
}
